import { render, staticRenderFns } from "./ventilation.vue?vue&type=template&id=3d81400e&scoped=true"
import script from "./ventilation.vue?vue&type=script&lang=js"
export * from "./ventilation.vue?vue&type=script&lang=js"
import style0 from "./ventilation.vue?vue&type=style&index=0&id=3d81400e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d81400e",
  null
  
)

export default component.exports